export const DiplomeOuTitrePlusEleve = [
  'BTS',
  'DUT',
  'AutreBac2',
  'BacPro',
  'BacGeneral',
  'BacTechno',
  'AutreBac',
  'CAP',
  'BEP',
  'MentionComplementaire',
  'AutreCAPBEP',
  'AucunDiplomeNiTitre',
] as const

export type DiplomeOuTitrePlusEleve = (typeof DiplomeOuTitrePlusEleve)[number]
